export function easing(t: number) {
  return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
}

export function checkIfScrollPositionIsGreaterThanThreshold(
  direction: number,
  currentScrollPosition: number,
  threshold: number,
) {
  const currentScrollPositionAsPercentOfSnapContainer =
    currentScrollPosition % 1;
  if (
    direction > 0 &&
    currentScrollPositionAsPercentOfSnapContainer > threshold
  ) {
    return true;
  }
  if (
    direction < 0 &&
    1 - currentScrollPositionAsPercentOfSnapContainer > threshold
  ) {
    return true;
  }
  return false;
}
